import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type RemoveAssetsFromShareMutationVariables = Types.Exact<{
  input: Types.RemoveAssetsFromShareInput;
}>;


export type RemoveAssetsFromShareMutation = { __typename?: 'Mutation', removeAssetsFromShare?: { __typename?: 'RemoveAssetsFromSharePayload', metadata?: { __typename?: 'RemoveAssetsFromShareMetadata', removedAssetIds: Array<string>, removedAt?: string | null } | null, share?: { __typename?: 'AdHocAssetsShare', id: string, name: string, aggregationInfo: { __typename?: 'AssetAggregateAggregationInfo', fileCount: number, folderCount: number }, thumbnailAssets?: Array<{ __typename?: 'InboxItemAsset', id?: string | null, assetType?: Types.AssetTypeEnum | null } | null> | null } | { __typename?: 'CollectionShare', id: string, name: string, aggregationInfo: { __typename?: 'AssetAggregateAggregationInfo', fileCount: number, folderCount: number } } | null } | null };


export const RemoveAssetsFromShare = /*#__PURE__*/ gql`
    mutation RemoveAssetsFromShare($input: RemoveAssetsFromShareInput!) {
  removeAssetsFromShare(input: $input) {
    metadata {
      removedAssetIds
      removedAt
    }
    share {
      id
      name
      ... on AssetAggregate {
        aggregationInfo {
          fileCount
          folderCount
        }
      }
      ... on AdHocAssetsShare {
        thumbnailAssets {
          id
          assetType
        }
      }
    }
  }
}
    ` as unknown as DocumentNode<RemoveAssetsFromShareMutation, RemoveAssetsFromShareMutationVariables>;

          

          export const useRemoveAssetsFromShareMutation = (options?:MutationHookOptions<RemoveAssetsFromShareMutation, RemoveAssetsFromShareMutationVariables>) => useMutation(RemoveAssetsFromShare, options);
          

          export type RemoveAssetsFromShareMutationOptions = MutationHookOptions<RemoveAssetsFromShareMutation, RemoveAssetsFromShareMutationVariables>;

          

          export type RemoveAssetsFromShareMutationResult = ReturnType<typeof useRemoveAssetsFromShareMutation>[1];

          
